import { Component, OnChanges } from '@angular/core';
import { CustomerManageService } from '../shared/customer-manage.service';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerCharacteristicType } from '../models/enums/customer-characteristic-type.enum';
import { CustomerCharacteristic } from '../models/customer-characteristic.model';

@Component({
    selector: 'historical-customer-characteristic',
    templateUrl: './historical-customer-characteristic.html',
    inputs: ['customerNumber', 'characteristics']
})
export class HistoricalCustomerCharacteristicComponent extends BaseComponent implements OnChanges {
    public characteristics: CustomerCharacteristic[];
    public customerNumber: number;
    public isSexOffender = false;

    private characteristicTypes = new CustomerCharacteristicType();

    constructor(private customerService: CustomerManageService) {
        super();
    }

    ngOnInit() {
        if (this.characteristics !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateHistoricalCharacteristics(this.customerNumber);
        }
    }

    ngOnChanges() {
        if (this.characteristics !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateHistoricalCharacteristics(this.customerNumber);
        }
    }

    populateHistoricalCharacteristics(customerNumberId: number) {

        this.customerService.getCustomerHistoricalCharacteristic(customerNumberId)
            .subscribe(result => {
                this.characteristics = result;

            },
            e => console.log('error', e),
            () => {
                this.denormalizeData();

                this.sexOffenderCheck();
            });
    }

    /**
     * Check to see if the current user has the sex offender characteristic.
     */
    public sexOffenderCheck() {
        // Sex offender check
        this.isSexOffender = false;
        this.characteristics.forEach(c => {
            if (c.customerCharacteristicTypeId == this.characteristicTypes.SexOffender.id) {
                this.isSexOffender = true;
            }
        });
    }

    denormalizeData() {
        for (const characteristic of this.characteristics) {
            characteristic.characteristicType = this.getValues(characteristic.customerCharacteristicTypeId, this.characteristicTypes);
        }
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }
}
